export interface SelectOption<T = unknown> {
  value: T;
  label: string;
}

export function filterSelectOptions<T>(
  options: SelectOption<T>[],
  query: string,
): SelectOption<T>[] {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) {
    return options;
  }

  return options.filter((option) =>
    option.label.toLowerCase().includes(normalizedQuery),
  );
}
